export default __webpack_public_path__ + "static/media/avatarBlack.5a3d3586.svg";